<template>
  <div>
    <div class="card">
      <div class="card-header">
        <i class="fa fa-align-justify"></i>
        Lista użytkowników
      </div>
      <div class="card-actions">
        <a href class="btn btn-secondary btn-sm mr-2" @click.prevent="toggleFiltersVisibility()">
          <span v-if="filtersVisible">Ukryj filtry</span>
          <span v-if="!filtersVisible">Pokaż filtry</span>
        </a>
        <router-link class="btn btn-sm btn-primary" :to="{name: 'userCreate'}">nowy użytkownik</router-link>
      </div>
      <div class="card-filters" v-if="filtersVisible">
        <form @submit.prevent="searchList()">
          <div class="row">
            <div class="form-group col-md-2">
              <label>Nazwisko</label>
              <input class="form-control" v-model="filters.qLastName" type="text"/>
            </div>
            <div class="form-group col-md-2">
              <label>Imiona</label>
              <input class="form-control" v-model="filters.qFirstName" type="text"/>
            </div>
            <div class="form-group col-md-2">
              <label>E-mail</label>
              <input class="form-control" v-model="filters.qEmail" type="text"/>
            </div>
            <div class="form-group col-md-2">
              <label>Obiekt</label>
              <select class="form-control" id="branchId" v-model="filters.qBranchId">
                <option value=""></option>
                <option value="1">Malinowy Zdrój</option>
                <option value="2">Malinowy Raj</option>
                <option value="3">Malinowy Dwór</option>
              </select>
            </div>
            <div class="form-group col-md-2">
              <label>Status</label>
              <select class="form-control" id="qStatus" v-model="filters.qStatus">
                <option value=""></option>
                <option value="1">Aktywny</option>
                <option value="0">Zablokowany</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12">
              <button type="submit" class="btn btn-primary">Szukaj</button>
              <button type="button" @click="clearFilters()" class="btn btn-link">Wyczyść filtry</button>
            </div>
          </div>
        </form>
      </div>
      <div class="card-body">
        <table class="table table-responsive-sm table-bordered table-striped">
          <thead class="">
          <tr>
            <th scope="col">Login</th>
            <th scope="col" @click="setOrderBy('lastName')">{{ $t('users.fullName') }}</th>
            <th scope="col">{{ $t('users.email') }}</th>
            <th scope="col">{{ $t('branchName')}}</th>
            <th scope="col">Typ konta</th>
            <th scope="col">Status</th>
            <th scope="col">{{ $t('common.actions') }}</th>
          </tr>
          </thead>
          <tbody>
          <tr class="loading" v-if="isLoading" v-bind:key="item" v-for="item in $store.state.usersParams.pageSize">
            <td v-bind:data-id="item"></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr v-if="!totalCount && !isLoading">
            <td colspan="6">
              Brak rekordów spełniających podane kryteria.
              Zmień lub <a href @click.prevent="clearFilters()">wyczyść filtry</a>.
            </td>
          </tr>
          <tr v-for="user in users" v-if="!isLoading" :key="user.userId" class="user-row">
            <td>{{ user.username}}</td>
            <td>{{ user.fullName }}</td>
            <td>{{ user.email }}</td>
            <td>{{ user.branchName }}</td>
            <td>{{ $t('users.permissions.' + user.permissions )}}</td>
            <td>{{ $t('users.status.' + user.active )}}</td>
            <td>
              <a href @click.prevent="goToDetails(user)">Szczegóły</a>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <list-pager
          v-bind:params-name="paramsName"
          v-bind:total-count="totalCount"
          @reload="loadItems()">
      </list-pager>
    </div>
  </div>

</template>

<script>
  import users from '@Service/users';
  import { router } from '@Router';
  import { toastError, listMixin } from '../helpers';
  import listPager from '@Component/list-pager';

  export default {
    data: function () {
      return {
        paramsName: 'usersParams',
        users: [],
        totalCount: 0,
        filters: {},
        filtersVisible: false,
        isLoading: false,
      };
    },
    mixins: [
      listMixin,
    ],
    components: {
      listPager,
    },
    methods: {
      goToDetails: (user) => {
        const { userId } = user;
        router.push({ name: 'userDetails', params: { userId } });
      },
      loadItems: function () {
        this.isLoading = true;
        return users.getUsers(this.$store.state.usersParams)
          .then(response => {
            this.totalCount = parseInt(response.headers.get('totalCount'), 10);
            this.users = response.data;
          })
          .catch(toastError)
          .finally(() => this.isLoading = false);
      },
      searchList: function () {
        this.$store.commit('setParams', {
          paramsName: this.paramsName,
          params: {
            ...this.filters,
            offset: 0,
          },
        });
        this.loadItems();
      },
      clearFilters: function () {
        this.filters = {
          qLastName: '',
          qFirstName: '',
          qEmail: '',
          qBranchId: '',
          qStatus: '',
          offset: 0,
        };
        this.searchList();
      },
    },
    mounted: function () {
      this.filters = {
        qEmail: this.$store.state.usersParams.qEmail,
        qFirstName: this.$store.state.usersParams.qFirstName,
        qLastName: this.$store.state.usersParams.qLastName,
        qBranchId: this.$store.state.usersParams.qBranchId,
        qStatus: this.$store.state.usersParams.qStatus,
      };
      this.filtersVisible = this.$store.state.usersParams.filtersVisible;
      this.loadItems();
    },
  };
</script>
<style>

</style>